(() => {
  'use strict';
  const log = (operation, error, context = {}) => console.error({timestamp: new Date().toISOString(), level: 'ERROR', module: 'mms-gift-personalization.js', operation, ...context, stack: error.stack});
  try {
    document.querySelectorAll('[data-gift-personalization]').forEach(panel => {
      const form = panel.closest('form');
      panel.querySelectorAll('[data-gift-text]').forEach(input => {
        const validate = () => {
          const limit = Number(input.dataset.giftMaxItems || 0);
          const names = input.value.split(/[,\n]/).map(name => name.trim()).filter(Boolean);
          let message = input.required && !input.value.trim() ? 'Please enter your personalization details.' : '';
          if (limit && names.length > limit) message = `Please enter up to ${limit} names, separated by commas.`;
          if (limit && input.required && !names.length) message = 'Please enter at least one name.';
          input.setCustomValidity(message);
        };
        input.addEventListener('input', validate);
        validate();
      });
      panel.querySelectorAll('[data-gift-photo-field]').forEach(field => {
        const input = field.querySelector('[data-gift-photo-upload]');
        const preview = field.querySelector('[data-gift-photo-preview]');
        let url = null;
        const clear = () => { if (url) URL.revokeObjectURL(url); url = null; preview.hidden = true; preview.querySelector('img').removeAttribute('src'); };
        input.addEventListener('change', () => {
          clear(); input.setCustomValidity('');
          const file = input.files[0];
          if (!file) return;
          if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 5 * 1024 * 1024) {
            input.value = ''; input.setCustomValidity('Choose a JPG, PNG or WebP photo up to 5 MB.'); input.reportValidity(); return;
          }
          url = URL.createObjectURL(file); preview.querySelector('img').src = url; preview.hidden = false;
        });
        field.querySelector('[data-gift-photo-remove]').addEventListener('click', () => { input.value = ''; input.dispatchEvent(new Event('change', {bubbles: true})); input.focus(); });
        window.addEventListener('pagehide', clear);
        window.addEventListener('pageshow', event => {
          if (event.persisted && input.files.length) input.dispatchEvent(new Event('change', {bubbles: true}));
        });
      });
      form.addEventListener('invalid', () => { panel.open = true; }, true);
    });
  } catch (error) { log('GIFT_PERSONALIZATION_INIT_FAILED', error, {trigger: 'product page initialization'}); }
})();
